import { django } from "@/api";
import { PromptHistory } from "@/types";

export const getPromptHistory = async (
  signal: AbortSignal | undefined,
  project?: string
): Promise<PromptHistory[]> => {
  const response = await django.get("llm/history", { params: { project }, signal });
  return response.data.reverse();
};
